import React, { useState, useEffect } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { Col, Row } from "react-bootstrap";
import {
  editModeOn,
  generateYears,
  getFromDecreaptLocalStorage,
  seasonValues,
  titleCase,
} from "../../utilFunctions";
import NoDataFound from "../../utilsComponent/noDataFound";
import { format, formatDistance } from "date-fns";
import ListsPagination from "../../utilsComponent/ListsPagination";
import FieldSurveyRequest from "../fieldSurveyRequest";
import {
  fetchDistricts,
  fetchMandals,
  fetchStates,
  fetchVillages,
} from "../apiHelper";
import TextTruncate from "../../utilsComponent/textTruncate";
import LoadingPage from "../../reusableComponents/loader/loadingPage";
import {fetchFieldReSurveyDataApi, fetchFieldSurveyDataApi, fetchSurveyorList, fetchVendorsList, submitBulkSurveyAction, uploadApiHelper } from "./bulkApiHelper";
import AsteriskSymbol from "../../reusableComponents/AsteriskSymbol";
import { functionalities, pmfby, REGEX } from "../../consts";

const BulkSurveyAssignment = (props) => {
  const { productNames } = props;
  const payload = {
    claims: [],
    surveyorName: "",
    surveyorID: "",
    surveyorMobile: "",
    vendorName: "",
  };

  const resurveyPayload = {
    claims: [],
    surveyorName: "",
    surveyorID: "",
    surveyorMobile: "",
    vendorName: "",
    comments:""
  };
  const [fieldSurveyData, setFieldSurveyData] = useState([]);
  const [totalDataCount, setTotalDataCount] = useState(0)
  const [fieldResurveyData, setFieldResurveyData] = useState([]);
  const [enableFieldRequestButton, setEnableFieldRequestButton] = useState(false);
  const [enableReFieldRequestButton, setEnableReFieldRequestButton] = useState(false);
  const [statesList, setStatesList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [mandalList, setMandalList] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [surveyorList, setSurveyorList] = useState([]);
  const [vendorId, setVendorId] = useState("");
  const [surveyorId, setSurveyorId] = useState("");
  const [notifyPayload, setNotifyPayload] = useState(payload);
  const [notifyResurveyPayload, setNotifyResurveyPayload] =useState(resurveyPayload);
  const [bulkReSurveyLoading, setBulkReSurveyLoading] = useState(false);
  const [loading, setLoading] = useState(false)
  const [fieldnames, setFieldNames] = useState({
    size: 10,
    page: 1,
    seasonName: "",
    seasonYear: "",
    productId: "",
    state: "",
    district: "",
    mandal: "",
    vendorName: "",
    surveyorName: "",
  });
  const [buttonsStatus, setButtonsStatus] = useState("Bulk");
  const [isFileLoading, setIsFileLoading] = useState(false);
  const roleDataCookie = getFromDecreaptLocalStorage("roleData");
  const [fileSize, setfileSize] = useState(0);
  const [addedFiles, setAddedFiles] = useState([])
  const [fileInputAPi, setFileInputApi] = useState(null)
  const [file, setFile] = useState([]);
  const [formDataForAPi, setFormDataForAPi] = useState(null)
  var fileInput;

  const yearsFrom2023 = generateYears(2023);

  const setValue = (key, value) => {
    setFieldNames((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const defaultnames = {
    size: 10,
    page: 1,
    seasonName: "",
    seasonYear: "",
    productId: "",
    state: "",
    district: "",
    mandal: "",
    vendorId: "",
    surveyorId: "",
  };

  useEffect(() => {
    getStatesList();
    getVendorsList();
  }, []);

  useEffect(() => {
    if(vendorId && vendorId.length !== 0){
      getSurveyorList();
    }
  }, [vendorId]);

  const getStatesList = async (productID) => {
    const fetchedStates = await fetchStates(productID);
    setStatesList(fetchedStates);
  };

  const getDistrictList = async (state) => {
    const fetchedDistricts = await fetchDistricts(state, fieldnames.productId);
    setDistrictList(fetchedDistricts);
  };

  const getMandalList = async (district, state) => {
    if (district && state) {
      const fetchedMandals = await fetchMandals(district, state, fieldnames.productId);
      setMandalList(fetchedMandals);
    }
  };
  const getVillageList = async (mandal, district, state) => {
    if (mandal && district && state) {
      const fetchedVillages = await fetchVillages(mandal, district, state, fieldnames.productId);
      setVillageList(fetchedVillages);
    }
  };

  const getSurveyorList = async () => {
    try {
      const data = await fetchSurveyorList(vendorId);
      setSurveyorList(data);
    } catch (error) {
      console.error("Error in getSurveyorList:", error);
    }
  };
  
  const getVendorsList = async () => {
    try {
      const data = await fetchVendorsList();
      setVendorList(data);
    } catch (error) {
      console.error("Error in getVendorsList:", error);
    }
  };
  
  const submitBulkSurvey = async () => {
    let filteredData = fieldSurveyData
      .filter((data) => data.checked)
      .map((data) => ({ claimIntimationNumber: data.claim_id }));
    notifyPayload.claims = filteredData;
  
    setBulkReSurveyLoading(true);
    try {
      await submitBulkSurveyAction(
        notifyPayload,
        roleDataCookie,
        filteredData,
        false
      );
      getFieldSurveyData();
      setBulkReSurveyLoading(false);
      setNotifyPayload(payload);
    } catch (error) {
      console.error('Error in submitBulkSurvey:', error);
      setBulkReSurveyLoading(false);
    }
  };
  
  const submitBulkReSurvey = async (notifyPayload) => {
    let refilteredData = fieldResurveyData
      .filter((data) => data.checked)
      .map((data) => ({
        claimIntimationNumber: data.claim_id,
        fieldSurveyNumber: data.field_survey_number,
      }));
    notifyPayload.claims = refilteredData;
  
    setBulkReSurveyLoading(true);
    try {
      await submitBulkSurveyAction(
        notifyPayload,
        roleDataCookie,
        refilteredData,
        true,
        fieldResurveyData
      );
      getFieldReSurveyData();
      setBulkReSurveyLoading(false);
      setNotifyResurveyPayload(resurveyPayload);
    } catch (error) {
      console.error('Error in submitBulkReSurvey:', error);
      setBulkReSurveyLoading(false);
      setNotifyResurveyPayload(resurveyPayload);
    }
  };

  const getFieldSurveyData = async (page, size) => {
    setLoading(true)
    setEnableFieldRequestButton(false);
    if (page) {
      setValue('page', page);
    }
    if (size) {
      setValue('size', size);
    }
    try {
      const data = await fetchFieldSurveyDataApi(page, size, fieldnames);
      setFieldSurveyData(data.response);
      setTotalDataCount(data.count);
      setLoading(false)
    } catch (error) {
      console.error("Error in getFieldSurveyData:", error);
      setLoading(false)
    }
  };
  
  const getFieldReSurveyData = async (page, size) => {
    setLoading(true)
    setEnableReFieldRequestButton(false);
    if (page) {
      setValue('page', page);
    }
    if (size) {
      setValue('size', size);
    }
    try {
      const data = await fetchFieldReSurveyDataApi(page, size, fieldnames, vendorId, surveyorId);
      setFieldResurveyData(data.response);
      setTotalDataCount(data.count);
      setLoading(false)
    } catch (error) {
      console.error("Error in getFieldReSurveyData:", error);
      setLoading(false)
    }
  };

  const handleSubmit = () => {
    if (
      !fieldnames.seasonName ||
      !fieldnames.seasonYear ||
      !fieldnames.productId ||
      !fieldnames.state ||
      !fieldnames.district ||
      !fieldnames.mandal
    ) {
      toast.error("Please select all required fields.");
      return;
    }
    getFieldSurveyData();
  };

  const handleReSubmit = () => {
    if (!fieldnames.state || !vendorId.value || !surveyorId.value) {
      toast.error("Please enter all required fields.");
      return false;
    }
    getFieldReSurveyData();
    return true;
  };

  const handleSelectAll = (status, surveyType) => {
    let updatedArray = [];
    if (surveyType === "bulkSurvey") {
      if (status) {
        updatedArray = fieldSurveyData.map((obj) => ({
          ...obj,
          checked: false,
        }));
      } else {
        updatedArray = fieldSurveyData.map((obj) => ({
          ...obj,
          checked: true,
        }));
      }
      setFieldSurveyData([...updatedArray]);
      const anyChecked = updatedArray.some((obj) => obj.checked);
      setEnableFieldRequestButton(anyChecked);
    } else {
      if (status) {
        updatedArray = fieldResurveyData.map((obj) => ({
          ...obj,
          checked: false,
        }));
      } else {
        updatedArray = fieldResurveyData.map((obj) => ({
          ...obj,
          checked: true,
        }));
      }
      setFieldResurveyData([...updatedArray]);
      const anyChecked = updatedArray.some((obj) => obj.checked);
      setEnableReFieldRequestButton(anyChecked);
    }
  };

  const handleSelect = (claimList, survey) => {
    if (survey === "bulkSurvey") {
      const updatedArray = fieldSurveyData.map((obj) => {
        if (obj.claim_id === claimList.claim_id) {
          return { ...obj, checked: !obj.checked };
        }
        return obj;
      });
      setFieldSurveyData([...updatedArray]);
      const anyChecked = updatedArray.some((obj) => obj.checked);
      setEnableFieldRequestButton(anyChecked);
    } else {
      const updatedArray = fieldResurveyData.map((obj) => {
        if (obj.claim_id === claimList.claim_id) {
          return { ...obj, checked: !obj.checked };
        }
        return obj;
      });
      setFieldResurveyData([...updatedArray]);
      const anyChecked = updatedArray.some((obj) => obj.checked);
      setEnableReFieldRequestButton(anyChecked);
    }
  };

  const resetSearchFields = () => {
    if (fieldnames.productId === pmfby) {
      getStatesList()
    }
    setFieldNames(defaultnames);
    setNotifyResurveyPayload(resurveyPayload)
    setSurveyorId("");
    setVendorId("");
    setFieldSurveyData([]);
    setFieldResurveyData([]);
    setTotalDataCount(0)
  };

  const uploadFile = (event) => {
    if (isFileLoading) {
      return;
    }
    const selectedFile = event.target.files[0];
    setFileInputApi(selectedFile);
    setFile([...file, selectedFile]);
  
    if (!selectedFile) {
      setIsFileLoading(false);
      return;
    }
  
    const formData = new FormData();
    const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
  
    if (Number((selectedFile.size / (1024 * 1024)).toFixed(4)) + fileSize > 50) {
      toast.error('File Size Should be Less Than 50MB.');
      setfileSize(fileSize);
      return;
    }
  
    if (fileExtension === 'xls' || fileExtension === 'xlsx') {
      setfileSize(fileSize + Number((selectedFile.size / (1024 * 1024)).toFixed(4)));
      formData.append('bulkUploadfile', selectedFile);
      formData.append('surveyInitiatedBy', roleDataCookie.userID); // Append surveyInitiatedBy here
      setAddedFiles([{ name: selectedFile.name }]);
      setFormDataForAPi(formData);
    } else {
      toast.error('File should be in the selected format');
      setIsFileLoading(false);
      event.target.value = '';
      return;
    }
  
    event.target.value = '';
  };

  const handleSubmitUpload = async () => {
    if (addedFiles.length === 0) {
      toast.error('Please Select Document.');
      return;
    }
    setIsFileLoading(true);
  
    try {
      await uploadApiHelper.uploadBulkFieldSurvey(formDataForAPi);
      toast.success('File Uploaded Successfully.');
      setAddedFiles([]);
    } catch (error) {
      console.log(error);
      toast.error('Something Went Wrong.');
    } finally {
      setIsFileLoading(false);
      setFileInputApi(null);
    }
  };

  useEffect(()=> {
    if (buttonsStatus) {
      setFieldSurveyData([])
      setFieldResurveyData([])
      resetSearchFields() 
    }
  }, [buttonsStatus])


  return (
    <div>
      <header>
        <h2
          className="ms-4 heading-roleMaster"
          style={{ color: "black", display: "flex" }}
        >
          Bulk Survey
        </h2>
      </header>
      <hr />
      {isFileLoading ? (
        <LoadingPage/>
      ) : (
        <>
          <div>
            <Row>
              <div
                className="form-group"
                style={{ display: "flex", gap: "1rem", marginLeft: "2rem" }}
              >
                <button
                  className={`${
                    buttonsStatus == "Bulk"
                      ? "btn btn-success mt-4 mb-4 px-4"
                      : "btn btn-outline-success mt-4 mb-4 px-4"
                  }`}
                  onClick={() => setButtonsStatus("Bulk")}
                >
                  Survey Assignment
                </button>
                <button
                  className={`${
                    buttonsStatus == "Re-Assignment"
                      ? "btn btn-success mt-4 mb-4 px-4"
                      : "btn btn-outline-success mt-4 mb-4 px-4"
                  }`}
                  onClick={() => setButtonsStatus("Re-Assignment")}
                >
                  Survey Re-Assignment
                </button>
                <button
                  className={`${
                    buttonsStatus == "Upload"
                      ? "btn btn-success mt-4 mb-4 px-4"
                      : "btn btn-outline-success mt-4 mb-4 px-4"
                  }`}
                  onClick={() => setButtonsStatus("Upload")}
                >
                  Upload
                </button>
              </div>
            </Row>
          </div>
          <div className="p-4 px-1">
            {buttonsStatus === "Bulk" && (
              <>
                <div className="border rounded pb-3">
                  <div className="d-md-flex align-items-center justify-content-around mt-3">
                    <div className="form-group w-20">
                      <label htmlFor="seasonName">
                        Season <AsteriskSymbol/>
                      </label>
                      <Select
                        id="seasonName"
                        options={seasonValues || []}
                        classNamePrefix="bg-gray"
                        placeholder="Assigned"
                        onInputChange={(inputValue) => {
                          const cleanedValue = inputValue.replace(REGEX.ALPHABET_REGEX, "");
                          return cleanedValue;
                        }}
                        value={
                          fieldnames.seasonName
                            ? seasonValues.find(
                                (seasonName) =>
                                  seasonName.value === fieldnames.seasonName
                              )
                            : { label: "Select Season", value: "Select Season" }
                        }
                        onChange={(data) => {
                          setValue("seasonName", data.value);
                        }}
                      />
                    </div>
                    <div className="form-group w-20">
                      <label htmlFor="yearFrom2023">
                        Year <AsteriskSymbol/>
                      </label>
                      <Select
                        id="yearFrom2023"
                        options={yearsFrom2023}
                        onInputChange={(inputValue) => {
                          const cleanedValue = inputValue.replace(REGEX.FOUR_DIGIT_NUMBER_REGEX, "");
                          return cleanedValue;
                        }}
                        classNamePrefix="bg-gray"
                        placeholder="Select Year"
                        value={
                          fieldnames.seasonYear
                            ? {
                                label: fieldnames.seasonYear,
                                value: fieldnames.seasonYear,
                              }
                            : {
                                label: "Select Season Year",
                                value: "Select Season Year",
                              }
                        }
                        onChange={(data) => {
                          setValue("seasonYear", data.value);
                        }}
                      />
                    </div>
                    <div className="form-group w-20">
                      <label htmlFor="productName">
                        Product Name <AsteriskSymbol/>
                      </label>
                      <Select
                        id="productName"
                        options={productNames}
                        onInputChange={(inputValue) => {
                          const cleanedValue = inputValue.replace(REGEX.ALPHABET_REGEX, "");
                          return cleanedValue;
                        }}
                        classNamePrefix="bg-gray"
                        placeholder="Kshema Product"
                        value={
                          fieldnames.productId
                            ? productNames.find(
                                (productNames) =>
                                  productNames.value === fieldnames.productId
                              )
                            : {
                                label: "Select Kshema Product",
                                value: "Select Kshema Product",
                              }
                        }
                        onChange={(data) => {
                          const isCurrentOrPreviousPMFBY = fieldnames.productId === pmfby || data.value === pmfby
                          setValue("productId", data.value);
                          if(isCurrentOrPreviousPMFBY) {
                            getStatesList(data.value);
                            setValue("state", "");
                            setValue("district", "");
                            setValue("mandal", "");
                            setValue("village", "");
                          }
                        }}
                      />
                    </div>
                    <div className="form-group w-20">
                      <label htmlFor="selectState">
                        State <AsteriskSymbol/>
                      </label>
                      <Select
                        id="selectState"
                        options={statesList || []}
                        classNamePrefix="bg-gray"
                        placeholder="Select State"
                        value={
                          fieldnames.state
                            ? {
                                label: fieldnames.state,
                                value: fieldnames.state,
                              }
                            : { label: "Select State", value: "Select State" }
                        }
                        onChange={(data) => {
                          getDistrictList(data.value);
                          setValue("state", data.value);
                          setValue("district", "");
                          setValue("mandal", "");
                          setValue("village", "");
                        }}
                      />
                    </div>
                  </div>
                  <div className="d-md-flex align-items-center justify-content-around mt-3">
                    <div className="form-group w-20">
                      <label htmlFor="selectDistrict">
                        District <AsteriskSymbol />
                      </label>
                      <Select
                        id="selectDistrict"
                        options={districtList}
                        classNamePrefix="bg-gray"
                        placeholder="Select District"
                        isDisabled={!fieldnames.state}
                        value={
                          fieldnames.district
                            ? {
                                label: fieldnames.district,
                                value: fieldnames.district,
                              }
                            : {
                                label: "Select District",
                                value: "Select District",
                              }
                        }
                        onChange={(data) => {
                          getMandalList(data.value, fieldnames.state);
                          setValue("district", data.value);
                          setValue("mandal", "");
                          setValue("village", "");
                        }}
                      />
                    </div>
                    <div className="form-group w-20">
                      <label htmlFor="selectMandal">
                        Mandal <AsteriskSymbol/>
                      </label>
                      <Select
                        id="selectMandal"
                        options={mandalList}
                        classNamePrefix="bg-gray"
                        placeholder="Select Mandal"
                        isDisabled={!fieldnames.district}
                        value={
                          fieldnames.mandal
                            ? {
                                label: fieldnames.mandal,
                                value: fieldnames.mandal,
                              }
                            : { label: "Select Mandal", value: "Select Mandal" }
                        }
                        onChange={(data) => {
                          getVillageList(
                            data.value,
                            fieldnames.district,
                            fieldnames.state
                          );
                          setValue("mandal", data.value);
                          setValue("village", "");
                        }}
                      />
                    </div>
                    <div className="form-group w-20">
                      <label htmlFor="selecVillage">Village</label>
                      <Select
                        id="selecVillage"
                        options={villageList}
                        classNamePrefix="bg-gray"
                        placeholder="Select Village"
                        value={
                          fieldnames.village
                            ? {
                                label: fieldnames.village,
                                value: fieldnames.village,
                              }
                            : null
                        }
                        onChange={(data) => {
                          setValue("village", data?.value);
                        }}
                        isDisabled={!fieldnames.mandal}
                        isClearable = {true}
                      />
                    </div>
                    <div className="form-group w-20"></div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex align-items-end justify-content-start">
                      <div className="form-group">
                        <button
                          className="btn btn-success m-3 mb-0 px-4 mt-4"
                          onClick={handleSubmit}
                        >
                          Search
                        </button>
                        <button
                          className="btn btn-outline-success m-3 mb-0 px-4 mt-4"
                          onClick={resetSearchFields}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    {( loading ? <LoadingPage/> :
                      fieldSurveyData && fieldSurveyData.length > 0 && 
                      <Row>
                        <Col xs={11}>
                          <h2 className="heading_h2">
                            Search Results ({totalDataCount})
                          </h2>
                        </Col>
                        {fieldSurveyData.length > 0 && (
                          <>
                            <Col xs={1}>
                                <FieldSurveyRequest
                                  id={fieldSurveyData[0]?.claimNo}
                                  claimDetailCookie={fieldSurveyData[0]}
                                  notifyPayload={notifyPayload}
                                  setNotifyPayload={setNotifyPayload}
                                  isBulkSurveyRequest={true}
                                  submitBulkSurvey={submitBulkSurvey}
                                  bulkReSurveyLoading={bulkReSurveyLoading}
                                  setBulkReSurveyLoading={setBulkReSurveyLoading}
                                  disableRequest = {!enableFieldRequestButton}
                                />
                            </Col>
                          </>
                        )}
                      </Row>
                    )}
                  </div>
                </div>
                {fieldSurveyData && fieldSurveyData.length > 0 ? (
                  <>
                  <div style={{overflowX: 'scroll'}}>
                    <table id="claim_historyclaim">
                      <tbody>
                        <tr>
                          {editModeOn(functionalities.BULK_SURVEY_TAB) && (
                            <th>
                              {/* Select */}
                              <input
                                type="checkbox"
                                checked={
                                  fieldSurveyData.length > 0 &&
                                  fieldSurveyData.length ===
                                    fieldSurveyData.filter((list) => list.checked)
                                      .length
                                }
                                onChange={() => {
                                  handleSelectAll(
                                    fieldSurveyData.length ===
                                      fieldSurveyData.filter(
                                        (list) => list.checked
                                      ).length,
                                    "bulkSurvey"
                                  );
                                }}
                              />
                            </th>
                          )}
                          <th>Claim Number</th>
                          <th>Policy Number</th>
                          <th>Product Name</th>
                          <th>Intimated Date & Time</th>
                          <th>Contact Number</th>
                          <th>Alternate Contact Number</th>
                          <th>Sub Status</th>
                          <th>IU Name</th>
                          <th>Batch ID</th>
                          <th>GIS Affected Area%</th>
                          <th>GIS Loss%</th>
                          <th>GIS Remarks</th>
                          <th>Field Survey Affected Area %</th>
                          <th>Field Survey Loss%</th>
                          <th>Qc Remarks</th>
                          <th>Affected Area %</th>
                          <th>Loss%</th>
                          <th>Net Payout</th>
                        </tr>

                        {fieldSurveyData.map((result, index) => (
                          <tr key={index} onClick={() => handleSelect(result, "bulkSurvey")}>
                            {editModeOn(functionalities.BULK_SURVEY_TAB) && (
                              <td>
                                <input
                                  type="checkbox"
                                  checked={result.checked}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    handleSelect(result, "bulkSurvey");
                                  }}
                                />
                              </td>
                            )}
                            <td>{result.claim_id}</td>
                            <td>{result.policy_id}</td>
                            <td>{result.product_id 
                              ? productNames.find(
                                  (product) =>
                                    product.value === result.product_id
                                )?.label || "--"
                              : "--"}
                          </td>
                            <td>
                              {format(
                                new Date(result.created_date),
                                "dd-MM-yyyy, hh:mm a"
                              )}
                            </td>
                            <td>{result.contactno || "--"}</td>
                            <td>{result.alternate_contactno || "--"}</td>
                            <td style={{ color: "#48d2ff" }}>
                              {result.claim_substatus}
                            </td>
                            <td>{result.g_iu_name || "--"}</td>
                            <td>{result.batch_id || "--"}</td>
                            <td>{result.affected_area_percentage || "--"}</td>
                            <td>{result.loss_percentage || "--"}</td>
                            <td>{<TextTruncate text={result.gis_remarks} length={15} /> || "--"}</td>
                            <td>{result.g_iu_name || "--"}</td>
                            <td>{result.g_iu_name || "--"}</td>
                            <td>{result.qc_status || "--"}</td>
                            <td>{result.affected_area_percentage || "--"}</td>
                            <td>{result.loss_percentage || "--"}</td>
                            <td>{result.net_payout_amount || "--"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                    <ListsPagination
                      fetchData={getFieldSurveyData}
                      dataCount={totalDataCount}
                    />
                  </>
                ) : (
                  <NoDataFound text="No Data Found" />
                )}
              </>
            )}

            {buttonsStatus === "Re-Assignment" && (
              <>
                <div className="border rounded pb-3">
                  <div className="d-md-flex align-items-center justify-content-around mt-3">
                    <div className="form-group w-20 col-3">
                      <label htmlFor="selectState">
                        State <AsteriskSymbol/>
                      </label>
                      <Select
                        id="selectState"
                        options={statesList}
                        classNamePrefix="bg-gray"
                        placeholder="Select State"
                        value={
                          fieldnames.state
                            ? {
                                label: fieldnames.state,
                                value: fieldnames.state,
                              }
                            : { label: "Select State", value: "Select State" }
                        }
                        onChange={(data) => {
                          getDistrictList(data.value);
                          setValue("state", data.value);
                          setValue("vendorName", " ")
                        }}
                      />
                    </div>
                    <div className="form-group w-20 col-3">
                      <label htmlFor="vendorName">
                        Vendor Name <AsteriskSymbol/>
                      </label>
                      <Select
                        id="vendorName"
                        options={vendorList}
                        classNamePrefix="bg-gray"
                        placeholder="Vendor Name"
                        onInputChange={(inputValue) => {
                          const cleanedValue = inputValue.replace(REGEX.ALPHABET_REGEX, "");
                          return cleanedValue;
                        }}
                        value={
                          vendorId.value
                            ? {
                                label: vendorId.value,
                                value: vendorId.value,
                              }
                            : {
                                label: "Select Vendor Name",
                                value: "Select Vendor Name",
                              }
                        }
                        onChange={(data) => {
                          setVendorId(data);
                          setSurveyorId("")

                        }}
                      />
                    </div>
                    <div className="form-group w-20 col-3">
                      <label htmlFor="surveyorName">
                        Surveyor Name <AsteriskSymbol/>{" "}
                      </label>
                      <Select
                        id="surveyorName"
                        options={surveyorList}
                        classNamePrefix="bg-gray"
                        placeholder="Select Surveyor Name"
                        value={
                          surveyorId
                            ? surveyorId
                            : {
                                label: "Select Surveyor Name",
                                value: "Select Surveyor Name",
                              }
                        }
                        onChange={(data) => {
                          setSurveyorId(data);
                        }}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 d-flex align-items-end justify-content-start">
                      <div className="form-group">
                        <button
                          className="btn btn-success m-3 mb-0 px-4 mt-4"
                          onClick={handleReSubmit}
                        >
                          Search
                        </button>
                        <button
                          className="btn btn-outline-success m-3 mb-0 px-4 mt-4"
                          onClick={resetSearchFields}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                  {(loading  ? <LoadingPage/> :
                   fieldResurveyData && fieldResurveyData.length > 0 && 
                      <Row>
                        <Col xs={11}>
                          <h2 className="heading_h2">
                            Search Results ({fieldResurveyData.length})
                          </h2>
                        </Col>
                        {fieldResurveyData.length > 0 && (
                          <>
                            <Col xs={1}>
                              <FieldSurveyRequest
                                  id={fieldResurveyData[0]?.claimNo}
                                  claimDetailCookie={fieldResurveyData[0]}
                                  notifyPayload={notifyResurveyPayload}
                                  setNotifyPayload={setNotifyResurveyPayload}
                                  isBulkReSurveyRequest={true}
                                  submitBulkReSurvey={submitBulkReSurvey}
                                  bulkReSurveyLoading={bulkReSurveyLoading}
                                  setBulkReSurveyLoading={setBulkReSurveyLoading }
                                  disableRequest = {!enableReFieldRequestButton}
                                  surveyorName = {fieldResurveyData[0].surveyor}
                                  requestButtonText = {'Re-Assign'}
                              />
                            </Col>
                          </>
                        )}
                      </Row>
                   )}
                  </div>
                </div>
                {fieldResurveyData && fieldResurveyData.length > 0 ? (
                  <>
                  <div style={{overflowX: 'scroll'}}>
                    <table id="claim_historyclaim">
                      <tbody>
                        <tr>
                          {editModeOn(functionalities.BULK_SURVEY_TAB) && (
                          <th>
                            {/* Select */}
                            <input
                              type="checkbox"
                              checked={
                                fieldResurveyData.length ===
                                fieldResurveyData.filter((list) => list.checked)
                                  .length
                              }
                              onChange={() => {
                                handleSelectAll(
                                  fieldResurveyData.length ===
                                    fieldResurveyData.filter(
                                      (list) => list.checked
                                    ).length,
                                  "bulkResurvey"
                                );
                              }}
                            />
                          </th>
                        )}
                          <th>Survey ID</th>
                          <th>Vendor Name</th>
                          <th>Surveyor Name</th>
                          <th>Survey Initiated by</th>
                          <th>Survey Initiated Date</th>
                          <th>Survey Completed Date</th>
                          <th>Aging</th>
                          <th>Survey Remarks</th>
                          <th>Survey Status</th>
                          <th>Qc Status</th>
                        </tr>

                        {fieldResurveyData.map((result, index) => (
                          <tr key={index}>
                             {editModeOn(functionalities.BULK_SURVEY_TAB) && (
                              <td>
                                <input
                                  type="checkbox"
                                  checked={result.checked}
                                  onChange={() => {
                                    handleSelect(result, "bulkResurvey");
                                  }}
                                />
                              </td>)}
                            <td>{result.field_survey_number}</td>
                            <td>{result.vendor}</td>
                            <td>{result.surveyor ? `${result.surveyor} (${result.surveyor_mobile_number})` : "--"}</td>
                            <td>{result.createdby}</td>
                            <td>
                              {format(
                                new Date(
                                  result.survey_initiated_date),
                                "dd-MM-yyyy, hh:mm a"
                              )}
                            </td>
                            <td>
                              {result.survey_received_date ?
                                format(
                                  new Date(
                                    result.survey_received_date?.split(".")[0]
                                  ),
                                  "dd-MM-yyyy, hh:mm a"
                                )
                              : "--"}
                            </td>
                            <td>
                              {( result?.survey_received_date) ? formatDistance(new Date( result?.survey_initiated_date), new Date(result?.survey_received_date)) : formatDistance(new Date(result?.survey_initiated_date), new Date())}
                              </td>
                            <td>{result.survey_remarks || "--"}</td>
                            <td>{result.survey_status ? titleCase(result.survey_status) : '--' }</td>
                            <td>{result.qc_status || "--"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                    <ListsPagination
                      fetchData={getFieldReSurveyData}
                      dataCount={totalDataCount}
                    />
                  </>
                ) : (
                  <NoDataFound text="No Data Found" />
                )}
              </>
            )}
              {buttonsStatus === "Upload" && (
                <>
                  <div className="d-flex ps-3" style={{ marginLeft: "30%" }}>
                    <div>
                      <div>
                        <p className="align3Policy" style={{ marginTop: "17px" }}>Attachment</p>
                        <div className="hoverPolicy">
                          <label for="fileInput">
                            <input type="file" id="fileInput" className="w-100" accept=".xls, .xlsx" hidden onClick={(e) => e.target.value = ""} onChange={uploadFile} />
                            <p className="align6_dataPolicy w-100">
                              <span className="plusPolicy" style={{ marginLeft: "2px" }} >+</span>
                              <span className="textPolicy" style={{ marginLeft: "0px" }} >Upload</span>
                            </p>
                          </label>
                          {
                            isFileLoading && (
                              <span className="spinner-border ms-4" role="status">
                                <span className="sr-only">Loading...</span>
                              </span>
                            )
                          }
                        </div>
                        <div className="align5Policy">File Size can not be more than 50 MB</div>
                      </div>
                      <div>
                        {
                          addedFiles && addedFiles.length > 0 && (
                            <>
                              <br></br>
                              <p className="align3Policy" style={{ marginTop: "-16px" }}>Attached Files</p>
                              <div className="attached_file_alignPolicy"
                                style={{
                                  height: '100px', // set the desired height of the div
                                  marginTop: "-5px",
                                  padding: '10px',
                                  maxHeight: "110px", // Set the maximum height of the textarea
                                  minHeight: "100px",
                                  width: "250px",
                                  minWidth: "12%",
                                  maxWidth: "30%",
                                  overflow: "auto", // Add scrollbars when content exceeds the maximum height
                                  resize: "auto",
                                }}
                              >
                                <div
                                  style={{
                                    // Add your content styles here
                                    minHeight: '30px', // ensures the content is taller than the container
                                  }}
                                >

                                  {
                                    addedFiles.map(file => (
                                      <div className="align_4_dataPolicy deletePolicy">
                                        <span className="hoverPolicy">{file.name}</span>
                                        <span className="marginPolicy hoverPolicy" onClick={() => { setAddedFiles(addedFiles.filter(list => list.id !== file.id)); setfileSize(fileSize - Number((file.size / (1024 * 1024)).toFixed(2))); }}>
                                          <img
                                            src="/kshemaImages/delete_symbol.png"
                                            alt="delete"
                                            height="18px"
                                            width="auto"
                                          />
                                        </span>
                                      </div>
                                    ))
                                  }
                              </div>
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                    <div>
                      {editModeOn(functionalities.BULK_SURVEY_TAB) &&
                        <button className="btn btn-success mt-3 ms-5" onClick={() => handleSubmitUpload()}>Submit</button>
                      }
                    </div>
                  </div>
                </>
              )}
          </div>
        </>
      )}
    </div>
  );
};

export default BulkSurveyAssignment;
